import script from "./object_course.vue?vue&type=script&setup=true&lang=js"
export * from "./object_course.vue?vue&type=script&setup=true&lang=js"

import "./object_course.vue?vue&type=style&index=0&id=0b5fc197&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b5fc197"]])

export default __exports__